import { render, staticRenderFns } from "./TextBackground.vue?vue&type=template&id=30187684&scoped=true&"
var script = {}
import style0 from "./TextBackground.vue?vue&type=style&index=0&id=30187684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30187684",
  null
  
)

export default component.exports